module.exports = "/ui/main/images/arrow-prev-no-bg.svg?f60ffff1acac25c148c95bdc2395a90a";